import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL || ""}/api`;
export const http = axios.create({ baseURL: API, withCredentials: true, timeout: 20000 });

http.interceptors.request.use((cfg) => {
  const t = sessionStorage.getItem("tme_admin_token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export function errMsg(e) {
  const d = e?.response?.data?.detail;
  if (!d) return e?.response?.status === 429 ? "Too many attempts. Please try again shortly." : "Something went wrong. Please try again.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => (typeof x?.msg === "string" ? x.msg.replace(/^Value error, /, "") : "")).filter(Boolean).join(" ");
  return String(d?.msg || d);
}

export function getUtm() {
  try {
    const p = new URLSearchParams(window.location.search);
    const keys = ["utm_source", "utm_medium", "utm_campaign"];
    const saved = JSON.parse(sessionStorage.getItem("tme_utm") || "{}");
    const fresh = Object.fromEntries(keys.map((k) => [k, p.get(k) || saved[k] || ""]));
    sessionStorage.setItem("tme_utm", JSON.stringify(fresh));
    return fresh;
  } catch {
    return { utm_source: "", utm_medium: "", utm_campaign: "" };
  }
}

export const isInAppBrowser = () => /Instagram|FBAN|FBAV|TikTok|musical_ly|Bytedance|BytedanceWebview|Line\//i.test(navigator.userAgent || "");

export const passImageUrl = (n, fmt) => `${API}/pass/${n}/image?format=${fmt}`;

export const media = (u) => (typeof u === "string" && u.startsWith("/api/") ? `${process.env.REACT_APP_BACKEND_URL || ""}${u}` : u || "");
